module.exports = __webpack_public_path__ + "static/img/head_img.d65b963.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/coreBusiness/head_img.png
// module id = faLq
// module chunks = 12